<template>
  <v-dialog
    ref="createDialog"
    v-model="dialogCreate"
    max-width="500px"
    persistent
  >
    <template v-slot:activator="{ props }">
      <v-btn
        variant="elevated"
        color="secondary"
        v-bind="props"
        class="ml-2 text-white"
      >
        <span>{{ $t("labels.create") }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.create-digital-twin") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="closeDialogCreate">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-5">
        <v-form v-model="validate" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.modelName"
                :label="$t('labels.name')"
                :hint="$t('strings.model-name')"
                persistent-hint
                variant="outlined"
                :rules="nameModel"
                required
                density="compact"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="editedItem.domain"
                :items="domainsList"
                :label="$t('labels.domain')"
                :hint="$t('strings.model-domain')"
                item-title="name"
                item-value="value"
                persistent-hint
                variant="outlined"
                :rules="domainModel"
                required
                density="compact"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editedItem.description"
                :label="$t('labels.description')"
                :hint="$t('strings.model-description')"
                auto-grow
                variant="outlined"
                rows="3"
                row-height="20"
                clearable
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          variant="text"
          @click="closeDialogCreate"
        >
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn
          color="secondary darken-1"
          variant="text"
          :disabled="!validate"
          @click="createModel"
        >
          {{ $t("labels.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogCreate",
  props: ["tenantId", "apiUrl", "domains"],
  data() {
    return {
      dialogCreate: false,
      editedItem: {
        modelName: "",
        description: "",
        domain: undefined,
      },
      defaultItem: {
        modelName: "",
        description: "",
        domain: undefined,
      },
      domainsList: this.domains,
      nameModel: [(value) => !!value || this.$t("errors.model-name-required")],
      domainModel: [
        (value) => !!value || this.$t("errors.model-domain-required"),
      ],
      descriptionModel: [
        (value) => !!value || this.$t("errors.model-description-required"),
      ],
      validate: false,
    };
  },
  computed: {},
  methods: {
    createModel() {
      if (this.validate) {
        this.editedItem.domain = this.editedItem.domain.toLowerCase();
        const obj = {
          ...this.editedItem,
          permissions: {
            ownership: true,
            capabilities: {
              canRead: true,
              canWrite: true,
            },
          },
          newModel: true,
        };

        sessionStorage.setItem("digital-twin-model", JSON.stringify(obj));
        this.$router.push({
          path: `/editor`,
        });
        this.closeDialogCreate();
      }
    },
    closeDialogCreate() {
      this.dialogCreate = false;
      this.resetDialog();
    },
    //RESET variables
    resetDialog() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>

<style scoped></style>
